import { Skeleton } from "@/app/components/shadcn/skeleton";

const TopHeaderSkeleton = () => {
  return (
    <div className="h-10 bg-black hidden md:block">
      <div className="container mx-auto h-full flex items-center justify-between">
        {/* Apps Skeleton */}
        <div className="flex items-center gap-2">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="flex items-center gap-2 h-8">
              <Skeleton className="w-4 h-4 rounded bg-gray-700" />
              <Skeleton className="h-3 w-20 rounded bg-gray-700" />
            </div>
          ))}
        </div>

        {/* Announcement Skeleton */}
        <Skeleton className="h-4 w-64 rounded bg-gray-700" />

        {/* Links Skeleton */}
        <div className="flex items-center gap-4">
          {Array.from({ length: 3 }).map((_, i) => (
            <Skeleton key={i} className="h-3 w-24 rounded bg-gray-700" />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TopHeaderSkeleton;